import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '~/redux/store'

interface BootcampVideoState {
  progressPercentage: number
  videoLength: number
  isPlaying: boolean
  hasEnded: boolean
  isReset: boolean
}

const initialState: BootcampVideoState = {
  progressPercentage: 0,
  videoLength: 1,
  isPlaying: false,
  hasEnded: false,
  isReset: false,
}

const slice = createSlice({
  name: 'bootcamp-video',
  initialState,
  reducers: {
    setProgressPercentage: (state, action: PayloadAction<number>) => ({
      ...state,
      progressPercentage: action.payload,
    }),
    setVideoLength: (state, action: PayloadAction<number>) => ({
      ...state,
      videoLength: action.payload,
    }),
    setPlaying: (state, action: PayloadAction<boolean>) => ({
      ...state,
      isPlaying: action.payload,
    }),
    setEnded: (state, action: PayloadAction<boolean>) => ({
      ...state,
      hasEnded: action.payload,
    }),
    setReset: (state, action: PayloadAction<boolean>) => ({
      ...state,
      isReset: action.payload,
    }),
  },
})

export const selectProgressPercentage = (state: RootState): BootcampVideoState['progressPercentage'] => {
  return state.bootcampVideo.progressPercentage
}
export const selectVideoLength = (state: RootState): BootcampVideoState['videoLength'] => {
  return state.bootcampVideo.videoLength
}
export const selectPlaying = (state: RootState): BootcampVideoState['isPlaying'] => {
  return state.bootcampVideo.isPlaying
}
export const selectEnded = (state: RootState): BootcampVideoState['hasEnded'] => {
  return state.bootcampVideo.hasEnded
}
export const selectReset = (state: RootState): BootcampVideoState['isReset'] => {
  return state.bootcampVideo.isReset
}

export const {
  setProgressPercentage: setProgressPercentageActionCreater,
  setVideoLength: setVideoLengthActionCreater,
  setPlaying: setPlayingActionCreater,
  setEnded: setEndedActionCreater,
  setReset: setResetActionCreater,
} = slice.actions

export default slice.reducer
